import { AppButton } from '@components/AppComponents'
import { observer } from 'mobx-react'

import store from '../../store'
import NotificationItem from '../NotificationItem'

const ContentNotification = () => {
  return (
    <div
      className="h-full max-h-full overflow-auto"
      key={store.refreshDropDownContent}
    >
      <div className="">
        {store.notifications.map(item => (
          <NotificationItem data={item} />
        ))}
      </div>
      {store.notifications.length >= 20 && (
        <AppButton
          onClick={() => {
            store.fetchNotifications({ skip: store.filter.skip + 20 })
          }}
        >
          Load more
        </AppButton>
      )}
    </div>
  )
}

export default observer(ContentNotification)
